<template>
  <router-view @authenticated='setAuthenticated'/>
</template>

<script>
import dispatcher from './dispatcher/dispatcher'

export default {
  name: 'App',
  data () {
    return {
      authenticated: false
    }
  },
  created () {
    dispatcher.getSessionInfo()
    .then((sessionInformation) => {
      this.setAuthenticated(sessionInformation && sessionInformation.exists)
    })
    .catch(() => {
      this.redirectIfNotAuthenticated()
    })
  },
  methods: {
    redirectIfNotAuthenticated () {
      if (!this.authenticated) {
        this.$router.replace({ name: 'login' })
      }
    },
    setAuthenticated (status) {
      console.log('status', status)
      this.authenticated = status
      this.redirectIfNotAuthenticated()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue